import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./styles/index.scss";
import "./styles/settings.scss";
import { LanguageProvider } from "./i18n/LanguageProvider"; // ⬅️ import nommé

ReactDOM.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
